import { compareAchievements, compareProgress } from './Utils';


const ACHIEVEMENTS_SERVICE = 'achievementsService';
const ACHIEVEMENTS_PROFILE = 'achievementsProfile';
const ACHIEVEMENTS_DISMISS = 'achievementsDismiss';
const ACHIEVEMENTS_ERROR = 'achievementsErrors';
const ACHIEVEMENTS_PROFILE_ERROR = 'achievementsProfileErrors';

const initialState = {
  achievements: [],
  achievementsUnlocked: [],
  achievementsLocked: [],
  achievementsProfile: [],
  notifications: { dismissed: null },
  profileErrors: {
    code: '',
    message: '',
    active: false,
  },
  errors: {
    code: '',
    message: '',
    active: false,
  },
};

export const NAME = 'itemsAchievements';

export default function achievements(state = initialState, action) {
  if (action.type === ACHIEVEMENTS_SERVICE) {
    const unlocked = [
      ...action.payload
        .filter((item) => item.completion !== null)
        .sort(compareAchievements),
    ];
    const inProgress = [
      ...action.payload
        .filter((item) => item.completion === null && item.progress !== null)
        .sort(compareProgress),
    ];
    const locked = [
      ...action.payload
        .filter((item) => item.completion === null && item.progress === null)
        .sort(compareAchievements),
    ];

    let { dismissed } = state.notifications;
    if (dismissed === null) {
      dismissed = unlocked.map(({ id }) => id);
    }

    return {
      ...state,
      achievements: [
        ...unlocked,
        ...inProgress,
        ...locked,
      ],
      achievementsUnlocked: [
        ...unlocked,
      ],
      achievementsLocked: [
        ...inProgress,
        ...locked,
      ],
      notifications: { dismissed },
      errors: {
        code: '',
        message: '',
        active: false,
      },
    };
  }

  if (action.type === ACHIEVEMENTS_DISMISS) {
    let { dismissed } = state.notifications;
    if (dismissed === null) {
      return state;
    }

    dismissed = [...dismissed, action.payload.id];

    return {
      ...state,
      notifications: { dismissed },
    };
  }

  if (action.type === ACHIEVEMENTS_PROFILE) {
    return {
      ...state,
      achievementsProfile: [
        ...action.payload
          .filter((item) => item.completion !== null)
          .sort(compareAchievements),
      ],
      profileErrors: {
        code: '',
        message: '',
        active: false,
      },
    };
  }

  if (action.type === ACHIEVEMENTS_PROFILE_ERROR) {
    return {
      ...state,
      profileErrors: { ...action.payload },
    };
  }

  if (action.type === ACHIEVEMENTS_ERROR) {
    return {
      ...state,
      errors: { ...action.payload },
    };
  }

  return state;
}
